<template>
  <!-- 车辆新增/编辑弹框 -->
  <a-modal
      :visible="visible"
      width="1100px"
      @cancel="handleCancel"
      @update:visible="(value) => emit('update:visible', value)"
  >
    <template #footer>
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '确定' }}
      </a-button>
    </template>
    <a-form
        :model="formData"
        :rules="rules"
        ref="formRef"
        layout="vertical"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <!-- 基本信息部分 -->
        <div class="vehicle-edit-section">
          <h3 class="vehicle-edit-title">基本信息</h3>
          <div class="vehicle-edit-row">
            <a-form-item label="生产企业" name="manufacturer">
              <a-input v-model:value="formData.manufacturer" placeholder="请输入生产企业" />
            </a-form-item>

            <a-form-item >

            </a-form-item>
          </div>
          <div class="vehicle-edit-row">
            <a-form-item label="车辆型号" name="model">
              <a-input v-model:value="formData.model" placeholder="请输入车辆型号" />
            </a-form-item>

            <a-form-item label="车辆种类" name="type">
              <a-select v-model:value="formData.type" placeholder="请选择车辆类型">
                <a-select-option v-for="item in vehicleTypeList" :key="item.id" :value="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="车辆识别代号(VIN)" name="vin">
              <a-input v-model:value="formData.vin" placeholder="请输入车辆识别代号" />
            </a-form-item>

            <a-form-item label="发动机号" name="engineNumber">
              <a-input v-model:value="formData.engineNumber" placeholder="请输入发动机号" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="车身颜色" name="color">
              <a-input v-model:value="formData.color" placeholder="请输入车身颜色" />
            </a-form-item>

            <a-form-item label="生产日期" name="productionDate">
              <a-date-picker v-model:value="formData.productionDate" value-format="YYYY-MM-DD" placeholder="请选择生产日期" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="最大设计总质量(kg)" name="maxDesignMass">
              <a-input v-model:value="formData.maxDesignMass" placeholder="请输入最大设计总质量" type="number" />
            </a-form-item>

            <a-form-item label="整车整备质量(kg)" name="curbWeight">
              <a-input v-model:value="formData.curbWeight" placeholder="请输入整车整备质量" type="number" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="轴荷(kg)" name="axleLoad">
              <a-input v-model:value="formData.axleLoad" placeholder="请输入轴荷" type="number" />
            </a-form-item>

            <a-form-item label="额定载客人数" name="ratedPassengerCapacity">
              <a-input v-model:value="formData.ratedPassengerCapacity" placeholder="请输入额定载客人数" type="number" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="动力型式" name="powerType">
              <a-input v-model:value="formData.powerType" placeholder="请输入动力型式" />
            </a-form-item>

            <a-form-item label="动力型式生产企业" name="powerTypeManufacturer">
              <a-input v-model:value="formData.powerTypeManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="发动机型号" name="engineModel">
              <a-input v-model:value="formData.engineModel" placeholder="请输入发动机型号" />
            </a-form-item>

            <a-form-item label="发动机型号生产企业" name="engineModelManufacturer">
              <a-input v-model:value="formData.engineModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="动力蓄电池型号" name="batteryModel">
              <a-input v-model:value="formData.batteryModel" placeholder="请输入动力蓄电池型号" />
            </a-form-item>

            <a-form-item label="动力蓄电池生产企业" name="batteryModelManufacturer">
              <a-input v-model:value="formData.batteryModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="动力电机型号" name="motorModel">
              <a-input v-model:value="formData.motorModel" placeholder="请输入动力电机型号" />
            </a-form-item>

            <a-form-item label="动力电机生产企业" name="motorModelManufacturer">
              <a-input v-model:value="formData.motorModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="驱动型式" name="driveType">
              <a-input v-model:value="formData.driveType" placeholder="请输入驱动型式" />
            </a-form-item>

            <a-form-item label="驱动型式生产企业" name="driveTypeManufacturer">
              <a-input v-model:value="formData.driveTypeManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="变速器型式" name="transmissionType">
              <a-input v-model:value="formData.transmissionType" placeholder="请输入变速器型式" />
            </a-form-item>

            <a-form-item label="变速器生产企业" name="transmissionTypeManufacturer">
              <a-input v-model:value="formData.transmissionTypeManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="行车制动系统型式" name="brakeSystemType">
              <a-input v-model:value="formData.brakeSystemType" placeholder="请输入行车制动系统型式" />
            </a-form-item>

            <a-form-item label="行车制动系统生产企业" name="brakeSystemTypeManufacturer">
              <a-input v-model:value="formData.brakeSystemTypeManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="转向系统型式" name="steeringSystemType">
              <a-input v-model:value="formData.steeringSystemType" placeholder="请输入转向系统型式" />
            </a-form-item>

            <a-form-item label="转向系统生产企业" name="steeringSystemTypeManufacturer">
              <a-input v-model:value="formData.steeringSystemTypeManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="ESC型号" name="escModel">
              <a-input v-model:value="formData.escModel" placeholder="请输入ESC型号" />
            </a-form-item>

            <a-form-item label="ESC生产企业" name="escModelManufacturer">
              <a-input v-model:value="formData.escModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="ACC型号" name="accModel">
              <a-input v-model:value="formData.accModel" placeholder="请输入ACC型号" />
            </a-form-item>

            <a-form-item label="ACC生产企业" name="accModelManufacturer">
              <a-input v-model:value="formData.accModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="AEB型号" name="aebModel">
              <a-input v-model:value="formData.aebModel" placeholder="请输入AEB型号" />
            </a-form-item>

            <a-form-item label="AEB生产企业" name="aebModelManufacturer">
              <a-input v-model:value="formData.aebModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="LKA型号" name="lkaModel">
              <a-input v-model:value="formData.lkaModel" placeholder="请输入LKA型号" />
            </a-form-item>

            <a-form-item label="LKA生产企业" name="lkaModelManufacturer">
              <a-input v-model:value="formData.lkaModelManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="轮胎规格" name="tireSpec">
              <a-input v-model:value="formData.tireSpec" placeholder="请输入轮胎规格" />
            </a-form-item>

            <a-form-item label="轮胎生产企业" name="tireSpecManufacturer">
              <a-input v-model:value="formData.tireSpecManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>

          <div class="vehicle-edit-row">
            <a-form-item label="ECU版本号" name="ecuVersion">
              <a-input v-model:value="formData.ecuVersion" placeholder="请输入ECU版本号" />
            </a-form-item>

            <a-form-item label="ECU生产企业" name="ecuVersionManufacturer">
              <a-input v-model:value="formData.ecuVersionManufacturer" placeholder="请输入生产企业" />
            </a-form-item>
          </div>
        </div>
    </a-form>
  </a-modal>
</template>

<script setup name="VehicleEditModal">
import { defineProps, defineEmits, ref, watch } from 'vue';
import { message } from 'ant-design-vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  vehicleTypeList: {
    type: Array,
    default: () => ([])
  },
  vehicle: {
    type: Object,
    default: () => ({})
  },
  isEdit: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'save']);
const formRef = ref();
const submitting = ref(false);

// 表单数据
const formData = ref({
  // 基本信息
  manufacturer: '',
  model: '',
  type: '',
  vin: '',
  engineNumber: '',
  color: '',
  productionDate: null,
  maxDesignMass: '',
  curbWeight: '',
  axleLoad: '',
  ratedPassengerCapacity: '',

  // 动力相关
  powerType: '',
  powerTypeManufacturer: '',
  engineModel: '',
  engineModelManufacturer: '',
  batteryModel: '',
  batteryModelManufacturer: '',
  motorModel: '',
  motorModelManufacturer: '',
  driveType: '',
  driveTypeManufacturer: '',

  // 系统相关
  transmissionType: '',
  transmissionTypeManufacturer: '',
  brakeSystemType: '',
  brakeSystemTypeManufacturer: '',
  steeringSystemType: '',
  steeringSystemTypeManufacturer: '',

  // ADAS相关
  escModel: '',
  escModelManufacturer: '',
  accModel: '',
  accModelManufacturer: '',
  aebModel: '',
  aebModelManufacturer: '',
  lkaModel: '',
  lkaModelManufacturer: '',

  // 其他
  tireSpec: '',
  tireSpecManufacturer: '',
  ecuVersion: '',
  ecuVersionManufacturer: ''
});

// 表单验证规则
const rules = {
  // 必填项验证
  manufacturer: [
    { required: true, message: '请输入生产企业', trigger: 'blur' }
  ],
  vin: [
    { required: true, message: '请输入车辆识别代号(VIN)', trigger: 'blur' }
  ],
  // model: [
  //   { required: true, message: '请输入车辆型号', trigger: 'blur' }
  // ],
  // type: [
  //   { required: true, message: '请输入车辆类型', trigger: 'blur' }
  // ],
};

// 重置表单
const resetForm = () => {
  if (formRef.value) {
    formRef.value.resetFields();
  }
  formData.value = {
    // 基本信息
    manufacturer: '',
    model: '',
    type: '',
    vin: '',
    engineNumber: '',
    color: '',
    productionDate: null,
    maxDesignMass: '',
    curbWeight: '',
    axleLoad: '',
    ratedPassengerCapacity: '',

    // 动力相关
    powerType: '',
    powerTypeManufacturer: '',
    engineModel: '',
    engineModelManufacturer: '',
    batteryModel: '',
    batteryModelManufacturer: '',
    motorModel: '',
    motorModelManufacturer: '',
    driveType: '',
    driveTypeManufacturer: '',

    // 系统相关
    transmissionType: '',
    transmissionTypeManufacturer: '',
    brakeSystemType: '',
    brakeSystemTypeManufacturer: '',
    steeringSystemType: '',
    steeringSystemTypeManufacturer: '',

    // ADAS相关
    escModel: '',
    escModelManufacturer: '',
    accModel: '',
    accModelManufacturer: '',
    aebModel: '',
    aebModelManufacturer: '',
    lkaModel: '',
    lkaModelManufacturer: '',

    // 其他
    tireSpec: '',
    tireSpecManufacturer: '',
    ecuVersion: '',
    ecuVersionManufacturer: '',
  };
};

// 处理取消事件
const handleCancel = () => {
  resetForm();
  emit('update:visible', false);
};

// 处理提交事件
const handleSubmit = async () => {
  if (!formRef.value) return;

  try {
    await formRef.value.validate();
    submitting.value = true;

    // 模拟提交
    setTimeout(() => {
      // 发送保存事件，包含isEdit标识和id
      emit('save', { 
        ...formData.value,
        id: props.vehicle.id || formData.value.id, // 保留现有id或使用表单中的id
        isEdit: props.isEdit,
        originalVin: props.vehicle.vin // 保存原始vin用于判断是否是同一条数据
      });
      handleCancel();
      submitting.value = false;
    }, 500);
  } catch (error) {
    console.error('表单验证失败:', error);
    message.error('请完善必填信息');
    submitting.value = false;
  }
};

// 监听vehicle属性变化，更新表单数据
watch(() => props.vehicle, (newVehicle) => {
  if (newVehicle && Object.keys(newVehicle).length > 0) {
    formData.value = { ...newVehicle };
  } else {
    // 重置表单
    resetForm();
  }
}, { deep: true });
</script>

<style scoped>
.vehicle-edit-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.vehicle-edit-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.vehicle-edit-row {
  display: flex;
  margin-bottom: 16px;
  padding-left: 20px;
  padding-right: 20px;
  gap: 16px;
}

.vehicle-edit-row > .ant-form-item {
  flex: 1;
  margin-bottom: 0;
}
</style>